import { FaqQuestionType } from './FAQ'

export const FaqQuestions: FaqQuestionType[] = [
  {
    title: 'Проведение обучения сотрудников партнера',
    descr: 'Рекомендации наших менеджеров по продажам, инструкции, презентации',
    children:
      'Опытные специалисты по обучению KION предоставляют качественное онлайн-обучение ваших сотрудников, а также все необходимые для продаж материалы и скрипты. Вашим сотрудникам будет доступна база знаний с каталогом курсов и еженедельная информационная поддержка, а также тестирование и развивающая обратная связь.',
  },
  {
    title: 'Разработка и печать маркетинговых материалов',
    descr:
      'Обсуждается индивидуально возможность печати и доставки до партнера',
    children:
      'KION поддерживает продажи продукта у партнеров на 360°, в том числе рекламными и информационными материалами. Плакаты, листовки, карточки с промокодами, рекламные баннеры на внешние фасады зданий и многое другое. Разработка нестандартных материалов для продаж по техническим требованиям партнера и доставка напрямую до места продажи. Клиент не уйдет с пустыми руками.',
  },
  {
    title: 'Регулярная отчетность для управления продаж',
    descr: 'Формат, глубина данных и регулярность обсуждаются индивидуально',
    children:
      'Для наших партнеров в разработке находится личный кабинет дилера, который позволит ежедневно отслеживать объемы активаций проданных подписок, а также качество подключений. Ежемесячно партнеру предоставляется отчет по расчету вознаграждения, поэтому сотрудничество с KION максимально прозрачно.',
  },
  {
    title: 'Прогнозный расчет вознаграждения на сайте',
    descr: 'С помощью калькулятора можно оперативно получить оценочный доход',
    children:
      'Представленный расчет на сайте является ориентировочным и учитывает среднерыночное качество подключений. Во многом данный показатель зависит от механики продаж, по которой реализуется сотрудничество. Финансовые условия обсуждаются индивидуально и зависят в первую очередь от целевых объемов продаж, которые может обеспечить партнер.',
  },
]
